export default __webpack_public_path__ + "static/media/Grassroots+Analytics-resized@3x.d61cd4e4.png";